import React from "react";


import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import { setUserCurrentScreen, setSelectedRiskIndex } from "../../redux/action/app";
import { updateUserProfile } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openRiskRecommendation } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";

const RiskQuestionnaire = () => {

  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);

  const [activeButton, setActiveButton] = React.useState("I'd sell at a loss");

  const onSubmit = () => {
    dispatch(updateUserProfile({ riskQuestionnaire: activeButton })).then(() => {
      let index = 0;
      utils.RADIO_ITEMS.forEach((item, i) => {
        if(item.label === activeButton){
          index = i
        }
      })
      dispatch(setSelectedRiskIndex(index));
      dispatch(setUserCurrentScreen(config.routes.riskRecommendation));
      openRiskRecommendation();
    });
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.RISK_QUESTIONNAIRE_HEADER}</h2>
        <p className={classes.SubHeading}>
          {utils.RISK_QUESTIONNAIRE_SUBHEADING}
        </p>
      </div>
      <div className={classes.middle}>
        {utils.RADIO_ITEMS.map((item) => {
          return (
            <RadioButton
              text={item.label}
              isActive={activeButton === item.label}
              setActive={setActiveButton}
            />
          );
        })}
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
        >
          {utils.RISK_QUESTIONNAIRE_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default RiskQuestionnaire;
